import { Panel } from "primereact/panel";
import FacultyFilter from "../../components/filters/FacultyFilter";
import SpecialityFilter from "../../components/filters/SpecialityFilter";
import { useSelector } from "react-redux";
import { Button } from "primereact/button";
import { useAppDispatch } from "../../hooks/redux";
import {
  clearScheduleFilters,
  getScheduleFiltersCount,
  getSelectedFaculties,
  getSelectedSpecialities,
  setSelectedFaculties,
  setSelectedSpecialities,
} from "../../services/schedule/scheduleSlice";

const ContextSidebar = (props: any) => {
  const scheduleFiltersCount = useSelector(getScheduleFiltersCount);
  const dispatch = useAppDispatch();

  const handleClearFilters = () => {
    dispatch(clearScheduleFilters());
  };

  return (
    <Panel
      header="Филтриране на учебни разписания"
      className="w-full mt-4 shadow-4"
      pt={{
        header: {
          className: "text-xl surface-ground font-light",
        },
      }}
      {...props}
    >
      {scheduleFiltersCount > 0 ? (
        <div className="h-5rem">
          <p className="text-sm text-gray-500">{scheduleFiltersCount} активни филтъра.</p>
          <Button
            label="Изчисти филтрите"
            icon="pi pi-times"
            severity="danger"
            outlined
            size="small"
            className="w-50 mb-4"
            onClick={handleClearFilters}
          />
        </div>
      ) : (
        <div className="h-5rem">
          <p className="text-sm text-gray-500">Няма активни филтри.</p>
          <div className="pi pi-sparkles pi-spin"></div>
        </div>
      )}
      <FacultyFilter getSelectedFaculties={getSelectedFaculties} setSelectedFaculties={setSelectedFaculties} />
      <SpecialityFilter
        getSelectedSpecialities={getSelectedSpecialities}
        setSelectedSpecialities={setSelectedSpecialities}
      />
    </Panel>
  );
};

export default ContextSidebar;
